export const isExternalLink = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);

    // Check if the origin ends with either 'nerdwallet.com' or 'nerdwallet.biz'
    const internalDomains = ['nerdwallet.com', 'nerdwallet.biz'];
    return !internalDomains.some(domain => parsedUrl.origin.endsWith(domain));
  } catch {
    // If the URL constructor throws an error (invalid or relative URL), return false
    return false;
  }
};
